import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-fullscreen-dialog',
  templateUrl: './custom-fullscreen-dialog.component.html',
  styleUrls: ['./custom-fullscreen-dialog.component.scss'],
})
export class CustomFullscreenDialogComponent {
  @Input() visible = false;
  @Input() data: any;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  onOverlayClick(event: MouseEvent) {
    if (
      (event.target as HTMLElement).classList.contains('fullscreen-overlay')
    ) {
      this.onClose();
    }
  }
}
